 <template lang="pug">
.page.is-form.with-cover.page__light.pd-page.reset-password
  .page__form.inner-gap(v-loading="submitting")
    el-form.form(
      ref="form"
      label-position="top"
      :model="form"
      :rules="rules"
      @submit.native="submit"
      @keypress.native.enter="submit")

      .pd-container.framed
        h1.page__title Reset password
        .page__description Enter the email address associated with your account and we will send you instructions to reset your password.

        el-form-item.boxed(label="Email" prop="email")
          el-input(v-model="form.email")

        el-form-item(prop="role" v-if="!isLPDomain && !isBrokerDomain")
          el-radio-group(v-model="form.role")
            el-radio-button(label="vendor") I'm a Vendor
            el-radio-button(label="buyer") I'm a Buyer

        el-form-item
          el-button(type="primary" @click="submit" size="large") Send intructions
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ResetPassword',

  layout: 'landing',

  data () {
    return {
      submitting: false,
      form: {
        email: '',
        role: null
      },
      rules: {
        email: [
          { required: true, message: 'Please input your email', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
        ],
        role: { required: true, message: 'Please select your role' }
      }
    }
  },

  fetch ({ redirect, store }) {
    const logged = store.getters['authentication/logged']
    if (!logged) return
    return redirect(store.getters['authentication/redirectTo'])
  },

  head () {
    return {
      title: 'Reset password',
      meta: [
        { hid: 'description', name: 'description', content: 'Unlike other food distribution companies, the Pod platform uses a full-service, transparent, end-to-end distributor model.' }
      ]
    }
  },

  computed: {
    ...mapGetters({
      isLPDomain: 'authentication/isLPDomain',
      isBrokerDomain: 'authentication/isBrokerDomain'
    })
  },

  methods: {
    redirect () {
      this.$router.replace({
        name: 'index'
      })?.catch(this.$debug.log)
    },

    submit () {
      let role = this.form.role
      if (this.isLPDomain) role = 'logistics_partner'
      if (this.isBrokerDomain) role = 'broker'

      this.$refs.form.validate(valid => {
        if (!valid) return false
        this.submitting = true
        this.$api.authentication
          .resetPassword({
            ...this.form,
            role
          })
          .then(() => {
            this.$workflow.notify('We have sent you an email with further instructions. Please check your inbox.')
            this.redirect()
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-password {
  .linked {
    display: inline-block;
  }
}
</style>
